<template>
  <div class="noDubDialog">
    <div class="titleGrid">
      <div class="close-btn" @click="hide('Close')">
        <i class="icon-popup-close"></i>
      </div>
    </div>

    <div class="content">作品当前无配音，无法进行识别，请添加配音后再使用智能识别。</div>
    <!-- <div class="btnGrid">
      <div class="grayBtn" @click="hide('Cancel')">取消</div>
      <div class="buleBtn" @click="hide('Ok')">添加配音</div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "noDubDialog",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    hide(type) {
      this.$emit("resultHandler", { type: type });
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang='scss'>
@import "./commonStyle";
.noDubDialog {
  position: relative;
  width: 540px;
  height: 196px;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;
  border-radius: 4px;
  .titleGrid {
    position: absolute;
    width: 100%;
    position: relative;
    height: 40px;

    .close-btn {
      position: absolute;
      top: 14px;
      right: 17px;
      cursor: pointer;
    }
  }

  .content {
    position: absolute;
    top: 72px;
    width: 100%;
    padding: 0 81px;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
  }
  .btnGrid {
    position: absolute;
    margin: 0 auto;
    top: 152px;
    width: 100%;
    padding: 0 87px;
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/noDubDialog.vue